import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
// New Videos
import new1 from '../assets/class_boxing.mp4';
import new2 from '../assets/class_fitness.mp4';
import new3 from '../assets/class_group.mp4';
import new4 from '../assets/class_bootcamp.mp4';
// Old Videos
import old1 from '../assets/vid1.mp4';
import old2 from '../assets/vid2.mp4';
import old3 from '../assets/vid3.mp4';
import old4 from '../assets/vid4.mp4';

const classes = [
    // New Classes
    { id: 1, title: 'PRO BOXING', titleFr: 'BOXE PRO', video: new1, desc: 'Professional technique', descFr: 'Technique professionnelle' },
    { id: 2, title: 'CARDIO FITNESS', titleFr: 'FITNESS CARDIO', video: new2, desc: 'High intensity cardio', descFr: 'Cardio haute intensité' },
    { id: 3, title: 'TEAM TRAINING', titleFr: 'ENTRAÎNEMENT ÉQUIPE', video: new3, desc: 'Train together', descFr: 'Entraînez-vous ensemble' },
    { id: 4, title: 'BOOT CAMP', titleFr: 'BOOT CAMP', video: new4, desc: 'Push your limits', descFr: 'Dépassez vos limites' },
    // Old Classes
    { id: 5, title: 'BOXING BASICS', titleFr: 'BOXE DÉBUTANT', video: old1, desc: 'Master fundamentals', descFr: 'Maîtrisez les bases' },
    { id: 6, title: 'KICKBOXING', titleFr: 'KICKBOXING', video: old2, desc: 'Power and agility', descFr: 'Puissance et agilité' },
    { id: 7, title: 'GROUP WORKOUT', titleFr: 'GROUPE', video: old3, desc: 'Community fitness', descFr: 'Fitness en communauté' },
    { id: 8, title: 'STRENGTH', titleFr: 'FORCE', video: old4, desc: 'Build muscle', descFr: 'Renforcement musculaire' },
];

const ClassesSection = () => {
    const { language } = useLanguage();

    return (
        <section id="classes" className="py-24 bg-gray-800 overflow-hidden">
            <div className="container mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">
                        {language === 'en' ? 'OUR CLASSES' : 'NOS CLASSES'}
                    </h2>
                    <h3 className="text-xl text-gray-400 tracking-widest font-heading">
                        {language === 'en' ? 'LAFANI BOXE PROGRAMS' : 'PROGRAMMES LAFANI BOXE'}
                    </h3>
                </motion.div>

                {/* Infinite Scroll Container */}
                <div className="relative w-full overflow-hidden">
                    {/* The wrapper needs to be wide enough -> duplicate content */}
                    <div className="flex w-max space-x-6 animate-marquee hover:pause group">
                        {/* Duplicate the array to create seamless loop (x2) */}
                        {[...classes, ...classes].map((cls, index) => (
                            <div
                                key={`${cls.id}-${index}`}
                                className="flex-none w-72 md:w-80 rounded-3xl overflow-hidden relative group-item shadow-2xl shadow-black/40 transition-transform duration-300 hover:scale-105"
                            >
                                <div className="relative h-[450px]">
                                    <video
                                        className="w-full h-full object-cover transform transition-transform duration-700"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                    >
                                        <source src={cls.video} type="video/mp4" />
                                    </video>

                                    {/* Gradient Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/20 opacity-80 transition-opacity duration-300"></div>

                                    {/* Content */}
                                    <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 transition-transform duration-300 group-hover:translate-y-0">
                                        <span className="text-xs text-blue-400 font-bold tracking-wider uppercase mb-2 block">LAFANI BOXE</span>
                                        <h3 className="text-2xl font-heading font-bold text-white mb-2">
                                            {language === 'en' ? cls.title : cls.titleFr}
                                        </h3>
                                        <p className="text-gray-300 text-sm opacity-100 transition-opacity duration-300">
                                            {language === 'en' ? cls.desc : cls.descFr}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Left/Right Fade Overlay */}
                    <div className="absolute top-0 left-0 w-24 h-full bg-gradient-to-r from-gray-800 to-transparent z-10 pointer-events-none"></div>
                    <div className="absolute top-0 right-0 w-24 h-full bg-gradient-to-l from-gray-800 to-transparent z-10 pointer-events-none"></div>
                </div>
            </div>
        </section>
    );
};

export default ClassesSection;
